<template>
  <i class="ivu-icon ivu-icon-ios-loading demo-spin-icon-load"></i>
</template>
<script>
export default {
  name: "asyncLoading"
};
</script>
